export var AfriexTransactionChannel;
(function (AfriexTransactionChannel) {
    AfriexTransactionChannel["WIDGET"] = "WIDGET";
    AfriexTransactionChannel["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    AfriexTransactionChannel["MOBILE_MONEY"] = "MOBILE_MONEY";
    AfriexTransactionChannel["CARD"] = "CARD";
    AfriexTransactionChannel["CRYPTO"] = "CRYPTO";
    AfriexTransactionChannel["INTERNAL"] = "INTERNAL";
    AfriexTransactionChannel["ADMIN"] = "ADMIN";
    AfriexTransactionChannel["WALLET"] = "WALLET";
    AfriexTransactionChannel["VIRTUAL_BANK_ACCOUNT"] = "VIRTUAL_BANK_ACCOUNT";
    AfriexTransactionChannel["POOL_ACCOUNT"] = "POOL_ACCOUNT";
    AfriexTransactionChannel["ACH_BANK_ACCOUNT"] = "ACH_BANK_ACCOUNT";
    AfriexTransactionChannel["INTERAC"] = "INTERAC";
    AfriexTransactionChannel["UPI"] = "UPI";
    AfriexTransactionChannel["GLOBAL"] = "GLOBAL";
    AfriexTransactionChannel["VIRTUAL_CARD"] = "VIRTUAL_CARD";
    AfriexTransactionChannel["RFP"] = "RFP";
    AfriexTransactionChannel["SWIFT"] = "SWIFT";
    AfriexTransactionChannel["EFT"] = "EFT";
    AfriexTransactionChannel["WE_CHAT"] = "WE_CHAT";
    AfriexTransactionChannel["ALIPAY"] = "ALIPAY";
    AfriexTransactionChannel["PAYBILL_TILL"] = "PAYBILL_TILL";
    AfriexTransactionChannel["PAYMENT_LINQ"] = "PAYMENT_LINQ";
})(AfriexTransactionChannel || (AfriexTransactionChannel = {}));
//# sourceMappingURL=AfriexTransactionChannel.js.map